import { SET_PROFILE_DETAILS, SET_USER_PROFILE_TYPE } from "./types";

const initialState = {
    personalInfo: {},
    profileTab: "basicInfo"
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_PROFILE_DETAILS:
            return { ...state, personalInfo: action.payload };
        case SET_USER_PROFILE_TYPE:
            return { ...state, profileTab: action.payload };
        default:
            return { ...state };
    }
};
